// eslint-disable-next-line import/no-unresolved
import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';

import { getHdRelaySrc, isBuildTime } from '@powdr/utils';

import { WebcamFrame } from './styles';

export const Webcam = ({
  id,
  webcamGuid = null,
  relationships = null,
  disabled = false,
}) => {
  const hdRelaySrc = getHdRelaySrc(relationships);
  const hdRelayTitle = relationships?.hdRelayCam?.name || 'Webcam';
  // Thumbnail clones reuse the same slide id; give them a unique holder so HDRelay
  // can initialize without colliding with the main carousel instance.
  const holderId = disabled ? `webcam_holder_${id}_thumb` : `webcam_holder_${id}`;

  useEffect(() => {
    if (hdRelaySrc || !webcamGuid || isBuildTime()) return undefined;

    const hdrelayInterval = setInterval(() => {
      if (typeof HDRelay !== 'undefined') {
        // eslint-disable-next-line no-undef
        HDRelay.create({
          target: holderId,
          id: webcamGuid,
        });

        clearInterval(hdrelayInterval);
      }
    }, 100);

    return () => clearInterval(hdrelayInterval);
  }, [hdRelaySrc, webcamGuid, holderId]);

  if (isBuildTime() || (!hdRelaySrc && !webcamGuid)) return null;

  if (hdRelaySrc) {
    return (
      <WebcamFrame className="webcam-frame" $disabled={disabled}>
        <div className="webcam-holder">
          <iframe
            src={hdRelaySrc}
            title={hdRelayTitle}
            allow="autoplay; picture-in-picture; fullscreen"
            allowFullScreen
            tabIndex={disabled ? -1 : undefined}
          />
        </div>
      </WebcamFrame>
    );
  }

  return (
    <>
      <Helmet>
        <script src="//manage.hdrelay.com/js/hdrelay.js" type="text/javascript" async />
      </Helmet>
      <WebcamFrame className="webcam-frame" $disabled={disabled}>
        <div id={holderId} />
      </WebcamFrame>
    </>
  );
};

Webcam.propTypes = {
  id: PropTypes.string.isRequired,
  webcamGuid: PropTypes.string,
  disabled: PropTypes.bool,
  relationships: PropTypes.shape({
    hdRelayCam: PropTypes.shape({
      name: PropTypes.string,
      hdRelayLink: PropTypes.shape({
        uri: PropTypes.string,
      }),
    }),
  }),
};
